// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { FormJobReview } from '~/components/module/review';
// Others
// Styles, images, icons
import styles from './JobReview.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const JobReview = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/review']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box id='jobReviewPage' component={'div'} className={cx('container')}>
      <Box component={'h1'} className={cx('title')}>
        {t('review_job_title')}
      </Box>

      <Box component={'div'} className={cx('body')}>
        <FormJobReview />
      </Box>
    </Box>
  );
};

export default JobReview;
